import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { BLOGS, getBlogExcerpt } from '../data/blogs/index';
import '../styles/Blogs.css';

const Blogs = () => {
  const navigate = useNavigate();

  const sortedBlogs = useMemo(
    () => [...BLOGS].sort((a, b) => Number(b.featured) - Number(a.featured)),
    []
  );

  const featured = sortedBlogs.filter((blog) => blog.featured).slice(0, 2);

  return (
    <section id="blogs" className="blog-page">
      <div className="blog-archive">
        <div className="blog-hero">
          <div className="blog-hero-copy">
            <p className="blog-eyebrow">Writing room</p>
            <h1>Notes from the build desk, the research notebook, and the postmortem draft.</h1>
            <p className="blog-hero-text">
              I write these pieces the same way I build: around real projects, real tradeoffs, and the questions that show up once the novelty fades.
            </p>
            <div className="blog-hero-stats">
              <div>
                <strong>{BLOGS.length}</strong>
                <span>published essays</span>
              </div>
              <div>
                <strong>{featured.length}</strong>
                <span>featured reads</span>
              </div>
              <div>
                <strong>agentic AI</strong>
                <span>the current thread</span>
              </div>
            </div>
          </div>

          <div className="blog-hero-panel">
            <p className="blog-hero-panel-label">Start here</p>
            <div className="blog-hero-panel-list">
              {featured.map((blog) => (
                <button
                  key={blog.slug}
                  className="blog-hero-panel-item"
                  style={{ '--blog-accent': blog.accent }}
                  onClick={() => navigate(blog.redirectUrl)}
                >
                  <span>{blog.title}</span>
                  <em>{blog.readTime}</em>
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="blog-featured-grid">
          {sortedBlogs.map((blog, index) => (
            <article
              key={blog.slug}
              className={`blog-card${blog.featured ? ' blog-card--featured' : ''}${index === 0 ? ' blog-card--lead' : ''}`}
              style={{ '--blog-accent': blog.accent }}
            >
              <button className="blog-card-link" onClick={() => navigate(blog.redirectUrl)} aria-label={`Open ${blog.title}`}>
                <div className="blog-card-body">
                  <div className="blog-card-meta">
                    <span>{blog.kicker}</span>
                    <span>{blog.date}</span>
                    <span>{blog.readTime}</span>
                  </div>
                  <h2>{blog.title}</h2>
                  <p>{blog.summary || getBlogExcerpt(blog)}</p>
                  <div className="blog-card-tags">
                    {blog.tags?.slice(0, 4).map((tag) => (
                      <span key={tag} className="blog-tag">{tag}</span>
                    ))}
                  </div>
                  <div className="blog-cta-row">
                    <span className="blog-cta">Open essay</span>
                    <span className="blog-cta-arrow">↗</span>
                  </div>
                </div>
              </button>
            </article>
          ))}
        </div>

        <div className="blog-archive-footer">
          <p>These essays stay grounded in real technical choices, constraints, and failure modes rather than abstract commentary.</p>
          <p className="blog-archive-footnote">Open any post to read the full article with images, section anchors, and a repo link when one is available.</p>
        </div>
      </div>
    </section>
  );
};

export default Blogs;